/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";

function Releases({ data }) {
  // // AdReel
  // if (data) {
  //   var AdReel = data.AdReel.map(function (AdReel) {
  //     if (AdReel.state === "Demo") {
  //       return (
  //         <a key={AdReel.title} href={AdReel.url} alt="" target="_blank">
  //           <div className="AdReel-Wrap">
  //             <img src={`${AdReel.image}`} alt="" />
  //             <video
  //               autoPlay={true}
  //               loop={true}
  //               muted={true}
  //               playsInline={true}
  //             >
  //               <source src={`/videos/${AdReel.video}`} type="" />
  //             </video>
  //           </div>
  //         </a>
  //       );
  //     }
  //   });
  // }

  // if (data) {
  //   var WebShows = data.WebShow.map(function (WebShows) {
  //     return (
  //       <div key={WebShows.title} className="columns portfolio-item">
  //         <div className="item-wrap">
  //           <a href={WebShows.url} title={WebShows.title} target="_blank">
  //             <img alt={WebShows.title} src={`${WebShows.image}`} />
  //             <div className="overlay">
  //               <div className="portfolio-item-meta">
  //                 <h5>{WebShows.title}</h5>
  //                 <p>{WebShows.description}</p>
  //               </div>
  //             </div>
  //           </a>
  //         </div>
  //       </div>
  //     );
  //   });
  // }

  return (
    <div className="LatestR" id="release">
      <h2>NEWEST ADDITION TO OUR PORTFOLIO</h2>
      <div className="ReleaseC">
        <div className="ReleaseImg" />
        <div className="ReleaseContent">
          <h3>Ranneeti: Balakot & Beyond</h3>
          <p>
          "Ranneeti: Balakot And Beyond" is a gripping tribute to India's armed forces, delving into the complexities of modern warfare and the battle for perception in a digital age. The series follows RAW agent Kashyap Sinha and his team as they navigate through the aftermath of the Pulwama attacks and the subsequent airstrike on Balakot. Director Santosh Singh skillfully combines action, political drama, and spy thriller elements, creating a layered narrative that keeps viewers intrigued.
          </p>
        </div>
      </div>
      {/* <div className="ReleaseR">
        <h3>Latest Ad Reels</h3>
        <div className="grid-wrapperR">{WebShows}</div>
      </div> */}
    </div>
  );
}

export default Releases;
